export enum ReportDataModel {
    unknown = 0,
    clientSide = 1,
    serverSide = 2
}
